import { gql } from '@apollo/client';

export default gql`
  mutation CreateNotificationMutation($notification: NotificationInput!) {
    createNotification(input: { notification: $notification }) {
      notification {
        id
      }
    }
  }
`;
